export const COUNTRY_CODES = [
  "AU",
  "NZ",
  "GB",
  "US",
  "EU",
  "CA",
  "IE",
] as const;

export const CURRENCY_CODES = [
  "AUD",
  "NZD",
  "GBP",
  "USD",
  "EUR",
  "CAD",
] as const;

export type CountryCode = typeof COUNTRY_CODES[number];
export type CurrencyCode = typeof CURRENCY_CODES[number];

export interface CountryOption {
  label: string;
  code?: CountryCode;
  currency: CurrencyCode;
  disableForLocation?: boolean;
}

const COUNTRY_OPTIONS: CountryOption[] = [
  {
    label: "Australia",
    code: "AU",
    currency: "AUD",
  },
  {
    label: "New Zealand",
    code: "NZ",
    currency: "NZD",
  },
  {
    label: "United Kingdom",
    code: "GB",
    currency: "GBP",
  },
  {
    label: "United States",
    code: "US",
    currency: "USD",
  },
  {
    label: "Eurozone",
    code: "EU",
    currency: "EUR",
    disableForLocation: true
  },
  {
    label: "Canada",
    code: "CA",
    currency: "CAD",
  },
  {
    label: "Ireland",
    code: "IE",
    currency: "EUR",
  },
  {
    label: "Other",
    currency: "AUD",
  }
];

export default COUNTRY_OPTIONS;
